import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { COLORS, TEXT_SIZES } from '@helpers/constants'
import { Link } from 'react-router-dom'
import Icon from '@components/Icon'
import { AppContext } from '@state/context'

const BreadCrumbs = (props) => {
    const { darkText = false } = props
    const [state] = useContext(AppContext)
    const { breadcrumbs } = state.breadcrumbs
    const textSize = classNames(TEXT_SIZES.XXSMALL)
    const textColor = darkText ? COLORS.BLACK.TEXT : COLORS.WHITE.TEXT

    return (
        <div className={`flex flex-wrap my-4 min-h-[34px] items-center ${textSize}`}>
            <Link
                to={'/'}
                className={`mr-2 my-1 flex items-center ${textColor}`}
            >
                <Icon icon={'Home'} />

                <span className={`ml-2 ${textColor}`} >
                    <Icon icon={'Shevron'} />
                </span>
            </Link>

            {breadcrumbs.map(({ label, link }, key) =>
                key + 1 === breadcrumbs.length ? (
                    <span className={`my-1 ${darkText
                            ? COLORS.LIGHT_DARK_GREY.TEXT
                            : COLORS.MEDIUM_GREY.TEXT}`
                        }
                        key={key}
                    >
                        {label}
                    </span>
                ) : (
                    <Link
                        key={key}
                        to={link}
                        state={{ restoreBreadcrumbs: breadcrumbs.slice(0, key + 1) }}
                        className={`mr-2 my-1 flex items-center ${textColor}`}
                    >
                        {label}
                        <span className={`ml-2 ${textColor}`} >
                            <Icon icon={'Shevron'} />
                        </span>
                    </Link>
                )
            )}
        </div>
    )
}

BreadCrumbs.propTypes = {
    link: PropTypes.object,
    darkText: PropTypes.bool,
}

export default BreadCrumbs
